import React, {useReducer} from 'react';
import AuthContext from './authContext';
import AuthReducer from './authReducer';
import clienteAxios from '../../config/axios';
import tokenAuth from '../../config/tokenAuth';
import {
    REGISTRO_ERROR, 
    REGISTRO_EXITOSO,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    OBTENER_USUARIO,
    RESET_STATE,
    FACEBOOK_LOGIN,
    AGREGAR_CARRITO,
    ERROR_AGREGAR_CARRITO,
    ELIMINAR_CARRITO,
    ERROR_ELIMINAR_CARRITO,
    VER_CARRITO,
    ERROR_VER_CARRITO,
    PRECIO_FINAL,
    AGREGAR_PEDIDO,
    AGREGAR_PEDIDO_ERROR,
    OBTENER_PEDIDO_CLIENTE, 
    OBTENER_PEDIDO_CLIENTE_ERROR,
    ELIMINAR_PEDIDO,
    ELIMINAR_PEDIDO_ERROR,
  
} from '../../types/index';

const AuthState = props => {
    const initialState = {
        token : localStorage.getItem('token'),
        autenticado : null,
        cliente : null,
        mensaje : null,
        registrado: false,
        error : false,
        carrito : [],
        cargando : true,
        total_carrito : null,
        pedido : null,
        mercado_libre_init_point : null,

    }
    const [ state, dispatch ] = useReducer(AuthReducer, initialState);

    //FUNCIONES
    const registrarUsuario = async datos => {
        try {
            
            const respuesta = await clienteAxios.post('/api/clientes' , datos);
            

            dispatch({
                type : REGISTRO_EXITOSO,
                payload : respuesta.data.msg
            })
        } catch (error) {
            
            
            dispatch({
                type : REGISTRO_ERROR,
                payload: error.response.data.msg
            })
        }
    }

    const reiniciarErrorMensaje = async datos => {
        dispatch({
            type : RESET_STATE
        })
    }

    const usuarioAutenticado = async () => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token);
        }
        try {  
            const respuesta = await clienteAxios.get('/api/auth')
           
            dispatch({
                type : OBTENER_USUARIO,
                payload : respuesta.data.usuario
                })
          
        } catch (error) {
            if(error.response){
                dispatch({
                    type: LOGIN_ERROR,
                    payload : error.response.data.msg
               })
            }
        
          
        }
    }
    const login = async datos => {

        try {
            const respuesta = await clienteAxios.post('/api/auth', datos)
            
            dispatch({
                type : LOGIN_EXITOSO,
                payload : respuesta.data.token
            })

            await usuarioAutenticado()
        } catch (error) {
            if(error.message){
                  dispatch({
                    type : LOGIN_ERROR,
                    payload : error.message
                })
            }
            if(error.response){
                dispatch({
                    type : LOGIN_ERROR,
                    payload : error.response.data.msg
                })
         }
           
        }
    }
    const facebookLogin = async datos => {
        try {
            const respuesta = await clienteAxios.post('/api/auth/facebook', datos)
            dispatch({
                type : FACEBOOK_LOGIN,
                payload : respuesta.data.token
            })

            await usuarioAutenticado()
        } catch (error) {
         
            console.log(error);
            dispatch({
                type : LOGIN_ERROR,
                payload : error.response.data.msg
            })
        }
    }
    const logOut = async => {
        dispatch({
            type : CERRAR_SESION
        })
    }
    //FUNCION PARA AGREGAR ITEMS AL CARRITO
    const addCarrito = async (menu, cliente)   => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token);
        }
      
       const carrito = [];
       carrito.push(menu);
       
       try {
            const respuesta = await clienteAxios.put(`/api/clientes/add_carrito/${cliente.id}` , {carrito})
            dispatch({
                type : AGREGAR_CARRITO,
                payload : respuesta.data.msg 
            })
           
        } catch (error) {
            console.log(error);
            dispatch({
                type : ERROR_AGREGAR_CARRITO,
                payload : error.response.data.msg
            })
        }
       
    }

    //OBTENER CARRITO DEL CLIENTE
    const getCarrito = async cliente => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token)
        }
        try {
            const respuesta = await clienteAxios.get(`/api/clientes/get_carrito/${cliente.id}`)
                let total = 0
                respuesta.data.carrito.map(menu => {
                  return total += menu.subtotal
                })
                dispatch({
                    type : VER_CARRITO,
                    payload : respuesta.data.carrito
                })
                dispatch({
                    type : PRECIO_FINAL,
                    payload : total
                })
        } catch (error) {
            console.log(error);    
            dispatch({
                    type : ERROR_VER_CARRITO,
                    payload : error.response ? error.response.data.msg : error
                })
        }
        
       
    }

    //ELIMINAR ITEM DEL CARRITO
    const deleteCarrito = async (id,cliente) =>{
        
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token)
        }
        
        try {
            const respuesta = await clienteAxios.put(`/api/clientes/del_carrito/${cliente.id}`, {_id : id})
            
            dispatch({
                type : ELIMINAR_CARRITO,
                payload : respuesta.data.msg
            })
        } catch (error) {
            console.log(error);
            dispatch({
                type : ERROR_ELIMINAR_CARRITO,
                payload : error.response.data.msg
            })
        }
       
    }
    //REALIZAR PEDIDO
    const confirmarOrden= async(menu, cliente, domicilio,formaentrega,formaPago,precio_final) => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token)
        }
        let pedido = {}
        if(formaentrega) pedido.tipo = formaentrega;
        if (menu) pedido.menu = menu;
        if(precio_final) pedido.precio_total = precio_final;
        if(cliente) pedido.cliente_registrado = cliente.id;
        if(domicilio) pedido.domicilio = domicilio.calle;
        if(domicilio) pedido.barrio = domicilio.barrio;
        if(domicilio.referencia) pedido.referencia = domicilio.referencia
        if(formaPago) pedido.forma_pago = formaPago;
        try {
            const respuesta = await clienteAxios.post(`/api/pedidos`, pedido)
            dispatch({
                type : AGREGAR_PEDIDO,
                payload : respuesta.data.msg
            })
            getPedidoCliente(cliente);
            
        } catch (error) {
            console.log(error);
            if(error.message){
                dispatch({
                    type : AGREGAR_PEDIDO_ERROR,
                    payload: error.message
                })
            }else{
                dispatch({
                    type : AGREGAR_PEDIDO_ERROR,
                    payload: error.response.data.msg
                })
            }
          
        }
    }
    //OBTENER PEDIDO 
    const getPedidoCliente = async (cliente) => {
        const token = localStorage.getItem('token');
        if(token) tokenAuth(token);
        try {
            const respuesta = await clienteAxios.get(`/api/pedidos/cliente/${cliente.id}`);
            
            if(respuesta.data.pedido[0] === undefined){
                return
            }
            dispatch({
                type : OBTENER_PEDIDO_CLIENTE,
                payload : respuesta.data.pedido[0]
                
            })
        } catch (error) {
            console.log(error);
            dispatch({
                type : OBTENER_PEDIDO_CLIENTE_ERROR,
                payload : error.response.data.msg
            })
        }
    }

    //GENERA MERCADO PAGO
    const checkOut = async () => {

    }
    //ELIMINAR CARRITO COMPLETO
    const cancelarOrden = async cliente => {
        const token = localStorage.getItem('token');
        if (token) {
            tokenAuth(token)
        }
        try {
            const respuesta = await clienteAxios.delete(`/api/clientes/del_pedido/${cliente.id}`)
                dispatch({
                    type: ELIMINAR_CARRITO,
                    payload : respuesta.data.msg
                })
        } catch (error) {
            console.log(error);
            dispatch({
                type: ERROR_ELIMINAR_CARRITO,
                payload : error.response.data.msg
            })
        }
    }
    //ELIMINAR PEDIDO 
    const eliminarPedido = async pedido => {
        const token = localStorage.getItem('token');
        if(token) tokenAuth(token);
       
        try {
            const respuesta = await clienteAxios.delete(`/api/pedidos/${pedido._id}`)
            dispatch({
                type : ELIMINAR_PEDIDO,
                payload : respuesta.data.msg
            })
        } catch (error) {
            console.log(error);
            dispatch({
                type : ELIMINAR_PEDIDO_ERROR,
                payload : error.response.data.msg
            })
        }
    }
    //FUNCION QUE MUESTRA ERROR EN EL FORMULARIO DEL SALON
    const erroresForm = async => {
        dispatch({
            type : ERROR_AGREGAR_CARRITO,
            payload : "Debe completar los campos requeridos de MESA y REFERENCIA"
        })
    }
    //ERROR EN EL STEPPER DE SALON
    const errorStepper = async => {
        dispatch({
            type : ERROR_AGREGAR_CARRITO,
            payload : "No hay menu cargado, debe cargar un menu para  finalizar"
        })
    }
    //ELIMINAR BEBIDA DEL CARRITO
    const deleteBebida = async (cliente, id) => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token)
        }
       
        try {
            const respuesta = await clienteAxios.put(`/api/clientes/del_bebida/${cliente.id}`, {_id : id})
            
            dispatch({
                type : ELIMINAR_CARRITO,
                payload : respuesta.data.msg
            })
        } catch (error) {
            if(error.message){
                dispatch({
                    type : ERROR_ELIMINAR_CARRITO,
                    payload : error.message
                })
            }else{
                dispatch({
                    type : ERROR_ELIMINAR_CARRITO,
                    payload : error.response.data.msg
                })
            }
            
        }
    }
    //REALIZAR PEDIDO SALON
    const crearSalon = async (menu,mesa, referencia, precio_final) => {
        const token = localStorage.getItem('token');
        if(token){
            tokenAuth(token)
        }
        let pedido = {};
        pedido.tipo = "Salon"
        if(menu) pedido.menu = menu ;
        if(mesa) pedido.mesa = mesa ; 
        if(referencia) pedido.referencia = referencia;
        if(precio_final) pedido.precio_total = precio_final ; 
        try {
            const respuesta = await clienteAxios.post(`/api/pedidos`, pedido)
            dispatch({
                type : AGREGAR_PEDIDO,
                payload : respuesta.data.msg
            })
            
            
        } catch (error) {
            console.log(error);
            if(error.message){
                dispatch({
                    type : AGREGAR_PEDIDO_ERROR,
                    payload: error.message
                })
            }else{
                dispatch({
                    type : AGREGAR_PEDIDO_ERROR,
                    payload: error.response.data.msg
                })
            }
          
        }
    }
    //LIMPIAR CARRITO CUANDO NO SE FINALIZA EL PEDIDO
    const limpiarCarrito = async cliente => {
        const token = localStorage.getItem('token');
        if(token) tokenAuth(token);
        try {
            await clienteAxios.delete(`/api/clientes/clear_carrito/${cliente.id}`)
           
        } catch (error) {
            console.log(error);
            if(error.messagee){
                dispatch({
                    type : ERROR_ELIMINAR_CARRITO,
                    payload : error.message
                })
            }else{
                dispatch({
                    type : ERROR_ELIMINAR_CARRITO,
                    payload : error.response.data.msg
                })
            }
        }
    }
   
    return(
        <AuthContext.Provider
            value={{
                token : state.token,
                autenticado : state.autenticado,
                cliente : state.cliente,
                mensaje : state.mensaje,
                registrado : state.registrado,
                error : state.error,
                cargando : state.cargando,
                carrito : state.carrito,
                total_carrito : state.total_carrito,
                pedido : state.pedido,
                registrarUsuario,
                reiniciarErrorMensaje,
                login,
                usuarioAutenticado,
                facebookLogin,
                logOut,
                addCarrito,
                getCarrito,
                deleteCarrito,
                checkOut,
                confirmarOrden,
                getPedidoCliente,
                cancelarOrden,
                eliminarPedido,
                erroresForm,
                errorStepper,
                deleteBebida,
                crearSalon,
                limpiarCarrito
            }}
        >
            {props.children}

        </AuthContext.Provider>
    )
}

export default AuthState;